export default __webpack_public_path__ + "static/media/birds.d10d6252.svg";